<template>
  <div class="messages">
    <div class="userTitle1">
      <span class="iconfont iconwode">
        <svg
          width="20"
          height="20"
          viewBox="0 0 39 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0155306 44.0711C0.00492573 44.149 -0.000260386 44.2276 1.00532e-05 44.3063V44.4325C0.012648 44.5835 0.0430235 44.7324 0.0909145 44.8759C0.20741 45.2049 0.42307 45.4897 0.708181 45.691C0.993292 45.8923 1.33382 46.0003 1.68285 46C2.41673 46 3.42998 45.3615 3.40338 44.53C3.40338 35.832 10.4163 29.0275 19.1165 29.0275C19.2207 29.0275 19.2207 25.8745 19.1165 25.8745C8.83102 25.859 0.434577 33.872 0.0155306 44.0711ZM29.3865 32.6992C32.6568 35.648 34.9117 39.7163 34.9117 44.5145C34.8851 45.3459 35.8983 45.9845 36.6324 45.9845C36.9814 45.9848 37.322 45.8769 37.6071 45.6756C37.8922 45.4743 38.1079 45.1896 38.2244 44.8606C38.272 44.7169 38.3028 44.5679 38.3153 44.4172V44.2908C38.3153 44.2123 38.3104 44.1336 38.2997 44.0555C38.1951 41.409 37.5345 38.8141 36.361 36.4396C35.1874 34.0651 33.5272 31.9642 31.4884 30.2736C29.7501 29.012 27.7546 31.227 29.3865 32.6992V32.6992Z"
            fill="#fff"
          />
          <path
            d="M19.1208 0C11.9757 0 6.18359 5.79215 6.18359 12.9372C6.18359 20.0823 11.9757 25.8745 19.1208 25.8745C26.2659 25.8745 32.058 20.0821 32.058 12.9372C32.058 5.79215 26.2659 0 19.1208 0V0ZM19.1208 22.6418C13.7623 22.6418 9.41845 18.2979 9.41845 12.9394C9.41845 7.58097 13.7623 3.23708 19.1208 3.23708C24.4793 3.23708 28.8232 7.58097 28.8232 12.9394C28.8232 18.2979 24.4793 22.6418 19.1208 22.6418Z"
            fill="#fff"
          />
        </svg>
      </span>
      消息
    </div>
    <div class="userTitle2">
      <span>通知</span>
    </div>
    <!-- 列表页 -->
    <div class="innerDiv" v-show="isShowList">
      <template v-if="messageReqSuccessFlag">
        <!-- 列表 -->

        <div style="height: 5rem; overflow: auto; margin-top: 10px">
          <el-scrollbar style="height: 5rem" ref="multipleTable">
            <div
              class="messageItem cursorPoint noticeInfoBorderColor"
              v-for="(item, i) in messageDataList"
              :key="i"
              @click="showDetail(item.id)"
            >
              <div class="img">
                <img
                  v-if="item.readFlag != 0"
                  src="../../static/img/nInfoMsg.png"
                  alt
                />
                <img v-else src="../../static/img/nInfoMsgUnRead.png" alt />
              </div>
              <div class="msgContainer">
                <div class="msgTitle themeDark themeDark8">
                  {{ item.subject }}
                </div>
                <div class="msgContent themeLightColorClass">
                  {{ item.content }}
                </div>
                <div class="msgTime themeLightColorClass">
                  {{ item.publishedAt | timeSwitch }}
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>

        <!-- 底部 -->
        <div class="msgBottom">
          <div
            class="allDelete allBtn u-flex-all cursorPoint loginBtnStyle"
            @click="deleteAllMsgs"
          >
            全部删除
          </div>
          <div
            class="allBtn u-flex-all registerBtnStyle registerBtnStyle8"
            :class="
              needMarkReaded ? 'allReaded cursorPoint' : 'allReadedDisable'
            "
            @click="markAllRead"
          >
            全部已读
          </div>
          <div class="msgPagination">
            <el-pagination
              :current-page="currentPage"
              :page-size="pageSize"
              :hide-on-single-page="hidePagination"
              layout="pager"
              :total="totalRecords"
              :pager-count="5"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- 没数据 -->
        <Nothing img="nInfoMsgIsEmpty2" title="一条通知都没呢..."></Nothing>
      </template>
    </div>

    <!-- 详情页 -->
    <div class="innerDiv" v-show="!isShowList">
      <template v-if="JSON.stringify(messageDetail) != '{}'">
        <div class="msgDetailTitle themeDark themeDark8">
          {{ messageDetail.subject }}
        </div>
        <div class="msgDetailTime themeLightColorClass noticeInfoBorderColor">
          {{ messageDetail.publishedAt | timeSwitchAll }}
        </div>
        <div class="msgDetailContent themeLightColorClass">
          <el-scrollbar style="height: 100%">{{
            messageDetail.content
          }}</el-scrollbar>
        </div>
        <div class="msgBottom msgDetailBottom">
          <div
            class="detailDelete allBtn u-flex-all cursorPoint"
            @click="deleteMessage(messageDetail.id)"
          >
            删除
          </div>
          <div
            class="backToList allBtn u-flex-all cursorPoint"
            @click="backToList()"
          >
            返回
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Nothing from "../../components/nothing/nothing";
export default {
  name: "messages",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      //只有一页时，隐藏分页器
      hidePagination: false,
      messageDataList: [],
      isShowList: true,
      messageDetail: {},
      messageReqSuccessFlag: true, //默认请求有数据
      isScrollTop: false,
      isClick: false, //是否点击了（跳转详情）
    };
  },
  filters: {
    timeSwitch(val) {
      if (val) {
        var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + ".";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + ".";
        var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var time = Y + M + D;
        return time;
      }
    },
    timeSwitchAll(val) {
      if (val) {
        var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        var m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        var time = Y + M + D + h + m + s;
        return time;
      }
    },
  },
  props: {
    curPage: Number,
  },
  mounted() {
    this.getMessages();
  },
  methods: {
    async getMessages(str) {
      var _this = this;
      var data = {
        currentPage: _this.currentPage,
        pageSize: _this.pageSize,
        receiverType: 0,
      };
      var res = await _this.$http.post(_this.$api.message, data, true);
      if (res.code == 0) {
        //实现点击tab，显示列表首页
        if (str) {
          this.isShowList = true;
        }

        if (res.data.content.length > 0) {
          _this.messageReqSuccessFlag = true;
          _this.messageDataList = res.data.content;
          _this.totalRecords = res.data.totalRecords;

          this.$nextTick(() => {
            _this.$refs.multipleTable.wrap.scrollTop = 0;
          });
        } else {
          _this.messageReqSuccessFlag = false;
        }
      } else {
        _this.messageReqSuccessFlag = false;
        _this.$message.error(res.msg);
      }
    },
    currentChange(val) {
      this.currentPage = val;
      this.getMessages();
    },
    async deleteAllMsgs() {
      var _this = this;
      var messageIds = this.messageDataList.map(function (item) {
        return item.id;
      });
      //请求数据
      var data = {
        messageIds: messageIds,
        type: 0,
      };
      var res = await _this.$http.deleteArray(_this.$api.deleteMessages, data);
      if (res.code == 0) {
        //删除成功
        //刷新页面
        _this.$message.success("通知删除成功!");
        _this.currentPage--;
        _this.getMessages();
        //更新tab上通知的数量
        this.$store.commit("updateUnRead", "message");
      } else {
        _this.$message.error(res.msg);
      }
    },
    markAllRead() {
      //全部标记已读
      //若全部已读，退出
      if (!this.needMarkReaded) {
        return;
      }
      var messageIds = this.messageDataList.map(function (item) {
        return item.id;
      });
      this.markReaded(messageIds);
    },
    sizeChange() {},
    async showDetail(id) {
      if (this.isClick) {
        return;
      }

      this.isClick = true;
      //标记已读
      var item = this.messageDataList.filter(function (item) {
        return item.id == id;
      });
      if (!item[0].readFlag) {
        await this.markReaded(id);
      }

      //显示详情
      await this.messageDetailInter(id);
    },
    async markReaded(id) {
      //标记已读
      var _this = this;
      var messageIds = typeof id == "number" ? [id] : id;
      var data = {
        messageIds: messageIds,
        type: 0,
      };
      const res = await _this.$http.put(_this.$api.readMessages, data);
      if (res.code == 0) {
        //手动更新已读
        _this.messageDataList.map(function (item) {
          messageIds.map(function (it) {
            if (item.id == it) {
              item.readFlag = 1;
            }
          });
        });

        if (typeof id == "object") {
          _this.$message.success("通知全部已读成功!");
        }

        //已读后，更新myPage页面的已读标志
        _this.$store.commit("updateUnRead", "message");
      } else {
        _this.$message.error(res.msg);
      }
    },
    async messageDetailInter(id) {
      //站内信详情
      var _this = this;
      _this.isShowList = false;
      var data = id;
      const res = await _this.$http.get(_this.$api.messageInfo, data, true);
      if (res.code == 0) {
        _this.messageDetail = res.data;

        _this.isClick = false;
      } else {
        _this.$message.error(res.msg);
      }
    },
    async deleteMessage(id) {
      var _this = this;
      //请求数据
      var data = "0/" + id;
      var res = await _this.$http.delete(_this.$api.deleteMessage, data);
      if (res.code == 0) {
        //删除成功
        _this.$message.success("通知删除成功!");
        //刷新页面
        if (this.messageDataList.length > 1) {
          _this.getMessages();
        } else {
          _this.currentPage--;
          _this.getMessages();
        }

        //回到列表页
        _this.backToList();

        //更新tab上通知的数量
        this.$store.commit("updateUnRead", "message");
      } else {
        _this.$message.error(res.msg);
      }
    },
    backToList() {
      this.isShowList = true;
      //详情清空
      this.messageDetail = {};
    },
  },
  computed: {
    needMarkReaded() {
      //只要有一个未读，显示全部已读
      return this.messageDataList.some(function (item) {
        return item.readFlag == 0;
      });
    },
  },
  components: {
    Nothing,
  },
  watch: {
    curPage(n) {
      if (n) {
        //每次打开，默认请求第一页数据
        this.currentPage = 1;
        this.getMessages();
      }
    },
  },
};
</script>


<style scoped>
.u-flex-all {
  display: flex;
  align-items: center;
  justify-content: center;
}
.messages {
  position: relative;
  /* height: 100%; */
  flex: 1;
}
.messages > .innerDiv {
  width: 10rem;
  margin-left: 68px;
}
.messageItem {
  padding: 0.1rem 0;
  box-sizing: border-box;
  border-bottom: 0.01rem solid rgb(247, 247, 247);
  display: flex;
  position: relative;
}
.messageItem:last-child {
  border: none;
}
.messageItem .img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.15rem;
  position: relative;
  margin-top: 0.1rem;
}

.messageItem .img img {
  width: 100%;
  height: 100%;
}
.msgContainer {
  flex: 1;
  overflow: hidden;
}
.msgTitle {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  margin: 0.05rem 0;
  /* 溢出显示省略号 */
  width: 75%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.msgContent {
  height: 20px;
  font-size: 0.14rem;
  font-weight: 500;
  text-align: left;
  /* 溢出显示省略号 */
  width: 75%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.msgTime {
  position: absolute;
  top: 26px;
  right: 0;
  height: 14px;
  font-size: 14px;
  font-weight: 500;
}
.msgBottom {
  /* min-height: 0.68rem; */
  /* padding: 0.2rem 0; */
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /* border-top: 0.01rem solid #f4f4f4; */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  margin-top: 20px;
}
.allBtn {
  width: 1rem;
  height: 0.3rem;
  font-size: 0.14rem;
  background-color: #000;
  color: #fff;
}
.allDelete,
.detailDelete {
  margin-right: 0.15rem;
}

.allReaded,
.backToList {
  position: relative;
}
/* .allReaded:before{
  content: "";
  border-color:  #117fcc;
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  z-index: 5;
  border-radius: 0.2rem; 
  transition:width 0.5s ease-in;

}
.allReaded:hover:before{
  width: 100%;
} */
.allReadedDisable {
  opacity: 0.5;
}
.msgPagination {
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0rem;
}
.msgDetailTitle,
.msgDetailTime,
.msgDetailContent {
  text-align: left;
}
.msgDetailTitle {
  font-size: 0.16rem;
  font-weight: bold;
  line-height: 0.24rem;
  margin-top: 0.2rem;
}
.msgDetailTime {
  font-size: 0.14rem;
  font-weight: 500;
  line-height: 0.2rem;
  padding: 0.04rem 0 0.16rem 0;
  border-bottom: 1px solid rgb(247, 247, 247);
}
.msgDetailContent {
  height: 4rem;
  font-size: 0.14rem;
  font-weight: 500;
  line-height: 0.18rem;
  margin-top: 0.2rem;
  overflow: auto;
}
.msgDetailBottom {
  bottom: 0;
  border-top: none;
  justify-content: flex-end;
}
</style>
<style>
.messages .el-pager li {
  min-width: 20px !important;
  color: #9695a6 !important;
}
.messages .el-pager li.active {
  color: #e5414a !important;
}
.messages .el-pager li:hover {
  color: #e5414a !important;
}
.messages .el-scrollbar__wrap {
  overflow-x: hidden;
  padding-right: 0.2rem;
}
.messages .el-scrollbar__thumb {
  background-color: #e5414a !important;
}
.messages .el-scrollbar__bar.is-vertical {
  background: #f4f4f4;
}
</style>
